import React, { useState, useEffect } from "react";
import "../SideBar_1/Dashboard.css";
import { Image, Col, Row } from "react-bootstrap";

import Dash1 from "../../assets/cou-(1).svg";
import Dash2 from "../../assets/cou-(2).svg";
import Dash3 from "../../assets/cou-(3).svg";
import Dash4 from "../../assets/cou-(4).svg";
import VoucherSummary from "./VoucherSummary";
import TopVouchers from "./TopVouchers";
import { VoucherDashboardAPI } from "../API/Vouchers/VoucherDashboard";
import { Graph } from "./Graph";
import { useNavigate } from "react-router-dom";
import { RemoveSortkeys } from "../../Utils/LocalStorage";
import swal from "sweetalert";

const VouchersDashboard = (props) => {
  const { setLoading, loading } = props;

  const [blockData, setBlockData] = useState([]);
  const [GraphData, setGraphData] = useState([]);
  const [GraphData1, setGraphData1] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [TableData, setTableData] = useState([]);

  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);

  // search
  const [searchValue, setsearchValue] = useState("");
  // sort
  const [flag, setFlag] = useState({
    business_name: 0,
    voucher_name: 0,
    voucher_value: 0,
    download_count: 0,
    redeemed_count: 0,
  });

  const navigate = useNavigate();

  const win = window.location.href;

  useEffect(() => {
    RemoveSortkeys();
  }, [win]);

  useEffect(() => {
    setLoading(true);
    ApiLoad();
  }, []);

  useEffect(() => {
    handleSort();
  }, [pageNumber]);

  const ApiLoad = async () => {
    const cityId = localStorage.getItem("cityId");

    const data = {
      mms_city_id: parseInt(cityId),
      start_date: "",
      end_date: "",
      offset: searchValue ? 0 : pageNumber,
      search_value: searchValue,
    };
    const coupondetailData = await VoucherDashboardAPI(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (coupondetailData.status === 429) {
      swal({
        title: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(true);
    } else {
      setTableData(coupondetailData.data.top_vouchers);
      // pagination
      setTotalPageCount(coupondetailData.data.top_vouchers_rows);
      setLimit(coupondetailData.data.top_vouchers_limit);

      setBlockData(coupondetailData.data.top_section);
      setSummaryData(coupondetailData.data.voucher_summary);
      setGraphData(coupondetailData.data.sales_by_date);
      setGraphData1(coupondetailData.data.sales_by_volume);
    }
  };

  const handleSearchInput = (e) => {
    setsearchValue(e.target.value);
    if (e.target.value.length == 0) {
      ApiLoad();
    }
  };
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = async (e) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");

    const data = {
      mms_city_id: parseInt(cityId),
      start_date: "",
      end_date: "",
      search_value: searchValue,
      offset: searchValue ? 0 : pageNumber,
    };
    const coupondetailData = await VoucherDashboardAPI(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      swal({
        title: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(true);
    } else if (coupondetailData.success == false) {
      setLoading(false);
    } else {
      setLoading(false);
      setTableData(coupondetailData.data.top_vouchers);
      // pagination
      setTotalPageCount(coupondetailData.data.top_vouchers_rows);
      setLimit(coupondetailData.data.top_vouchers_limit);

      setBlockData(coupondetailData.data.top_section);
      setSummaryData(coupondetailData.data.voucher_summary);
      setGraphData(coupondetailData.data.sales_by_date);
      setGraphData1(coupondetailData.data.sales_by_volume);
    }
  };

  // sort
  // Api for sort
  const handleSort = async (search, sortNo, colValue) => {
    if (colValue) {
      localStorage.setItem("colValue", colValue);
    }
    if (sortNo) {
      localStorage.setItem("sortNo", sortNo);
    }

    const ColValue = localStorage.getItem("colValue");
    const SortNo = parseInt(localStorage.getItem("sortNo"));

    const cityId = localStorage.getItem("cityId");

    const data = {
      mms_city_id: parseInt(cityId),
      offset: search ? 0 : pageNumber,
      search_value: search,
      column_name: ColValue ? ColValue : colValue,
      sort_type: SortNo ? SortNo : sortNo,
    };
    const coupondetailData = await VoucherDashboardAPI(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (coupondetailData.status === 429) {
      swal({
        title: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(true);
    }else{
      setTableData(coupondetailData.data.top_vouchers);
    }
    
  };

  // function to sort-button
  const HandleSortCol = (value) => {
    // voucher_name: 0,
    if (value == "voucher_name") {
      if (flag.voucher_name === 0) {
        handleSort(searchValue, 1, "voucher_name");
        setFlag((item) => {
          return { ...item, voucher_name: 1 };
        });
      } else if (flag.voucher_name === 1) {
        handleSort(searchValue, 2, "voucher_name");
        setFlag((item) => {
          return { ...item, voucher_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "voucher_name");
        setFlag((item) => {
          return { ...item, voucher_name: 0 };
        });
      }
    }
    // business_name: 0,
    if (value == "bi_name") {
      if (flag.business_name === 0) {
        handleSort(searchValue, 1, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 1 };
        });
      } else if (flag.business_name === 1) {
        handleSort(searchValue, 2, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 0 };
        });
      }
    }
    // download_count:0
    if (value == "download_count") {
      if (flag.download_count === 0) {
        handleSort(searchValue, 1, "download_count");
        setFlag((item) => {
          return { ...item, download_count: 1 };
        });
      } else if (flag.download_count === 1) {
        handleSort(searchValue, 2, "download_count");
        setFlag((item) => {
          return { ...item, download_count: 2 };
        });
      } else {
        handleSort(searchValue, 0, "download_count");
        setFlag((item) => {
          return { ...item, download_count: 0 };
        });
      }
    }
    // voucher_value: 0,
    if (value == "voucher_value") {
      if (flag.voucher_value === 0) {
        handleSort(searchValue, 1, "voucher_value");
        setFlag((item) => {
          return { ...item, voucher_value: 1 };
        });
      } else if (flag.voucher_value === 1) {
        handleSort(searchValue, 2, "voucher_value");
        setFlag((item) => {
          return { ...item, voucher_value: 2 };
        });
      } else {
        handleSort(searchValue, 0, "voucher_value");
        setFlag((item) => {
          return { ...item, voucher_value: 0 };
        });
      }
    }
    // redeemed_count
    if (value == "redeemed_count") {
      if (flag.redeemed_count === 0) {
        handleSort(searchValue, 1, "redeemed_count");
        setFlag((item) => {
          return { ...item, redeemed_count: 1 };
        });
      } else if (flag.redeemed_count === 1) {
        handleSort(searchValue, 2, "redeemed_count");
        setFlag((item) => {
          return { ...item, redeemed_count: 2 };
        });
      } else {
        handleSort(searchValue, 0, "redeemed_count");
        setFlag((item) => {
          return { ...item, redeemed_count: 0 };
        });
      }
    }
  };

  return (
    <>
      {/* card */}
      <Row className="dashboard-card mt-4 VouchersDashboard">
        <Col md="3">
          <div className="card py-3">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image src={Dash1} height="27px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Life Time sales</p>
              <p className="dash-text2">
                $
                <span className="dash-text2">
                  {blockData["Life Time Sales"] == null
                    ? "0"
                    : blockData["Life Time Sales"]}
                </span>
              </p>
              <p className="text-right pb-3"></p>
            </div>
          </div>
        </Col>
        <Col md="3">
          <div className="card py-3">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image src={Dash2} height="27px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Year To Date Sales</p>
              <p className="dash-text2">
                $
                <span className="dash-text2">
                  {blockData["Year To date Sales"] == null
                    ? "0"
                    : blockData["Year To date Sales"]}
                </span>
              </p>
              <p className="text-right pb-3"></p>
            </div>
          </div>
        </Col>
        <Col md="3">
          <div className="card py-3">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image src={Dash3} height="27px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Monthly Sales</p>
              <p className="dash-text2">
                $
                <span className="dash-text2">
                  {blockData["This Month Sales"] == null
                    ? "0"
                    : blockData["This Month Sales"]}
                </span>
              </p>
              <p className="text-right pb-3"></p>
            </div>
          </div>
        </Col>
        <Col md="3">
          <div className="card py-3">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image src={Dash4} height="27px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Weekly Sales</p>
              <p className="dash-text2">
                $
                <span className="dash-text2">
                  {blockData["This Week Sales"] == null
                    ? "0"
                    : blockData["This Week Sales"]}
                </span>
              </p>
              <p className="text-right pb-3"></p>
            </div>
          </div>
        </Col>
      </Row>
      {/* graph */}
      <Graph
        GraphData={GraphData}
        GraphData1={GraphData1}
        setGraphData1={setGraphData1}
        setGraphData={setGraphData}
        setLoading={setLoading}
      />
      {/* summary */}
      <Row>
        <Col md="12">
          <VoucherSummary summaryData={summaryData} />
        </Col>
      </Row>
      {/* table */}

      <div className="mt-4">
        <TopVouchers
          TableData={TableData}
          totalPageCount={totalPageCount}
          setPageNumber={setPageNumber}
          limit={limit}
          handleSearchInput={handleSearchInput}
          handleKeypress={handleKeypress}
          handleSearch={handleSearch}
          searchValue={searchValue}
          HandleSortCol={HandleSortCol}
          flag={flag}
        />
      </div>
    </>
  );
};

export default VouchersDashboard;
